/* eslint-disable @typescript-eslint/naming-convention */

import { Platform } from "react-native"

import {
  createExternalLinkClickedEvent,
  createScreenViewedEvent,
  track,
} from "./base"

const CURRENT_SCREEN = "Force Upgrade"

export const forceUpgradeViewed = () => {
  track(createScreenViewedEvent({ current_screen: CURRENT_SCREEN }))
}

export const forceUpgradeStoreLinkClicked = ({
  linkText,
  linkUrl,
}: {
  linkText: string
  linkUrl: string
}) => {
  track(
    createExternalLinkClickedEvent({
      current_screen: CURRENT_SCREEN,
      to_screen: Platform.OS === "android" ? "Ext:Play Store" : "Ext:App Store",
      component_type: "button",
      link_text: linkText,
      link_url: linkUrl,
    })
  )
}
